import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Info, Projects, RecentActivities, ProjectsQueryResponse, TimeTrackingSquadRandomAdm, RecentActivitiesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const DASHBOARD_URL = `${API_URL}/api/dashboard`

const getDashboardInfo = (): Promise<Info> => {
  return axios
    .get(`${DASHBOARD_URL}/dashbord-info`)
    .then((response: AxiosResponse<Response<Info>>) => response.data)
    .then((response: Response<Info>) => response.data)
}

const getDashboardTrends = (): Promise<import('./_models').DashboardTrends> => {
  return axios
    .get(`${DASHBOARD_URL}/trends`)
    .then((res: AxiosResponse<{data: import('./_models').DashboardTrends}>) => res.data.data)
}

// `period` filtra APENAS os contadores de entrega (userTaskDeliveryQuantity /
// userTaskNotDeliveryQuantity), por data de entrega real. Sem `period`, comportamento geral.
const getDashboardInfoUser = (period?: {beginDate?: string; endDate?: string}): Promise<Info> => {
  const params: Record<string, string> = {}
  if (period?.beginDate) params.beginDate = period.beginDate
  if (period?.endDate) params.endDate = period.endDate

  return axios
    .get(`${DASHBOARD_URL}/dashbord-info-user`, {params})
    .then((response: AxiosResponse<Response<Info>>) => response.data)
    .then((response: Response<Info>) => response.data)
}

const getProjects = (params?: {limit?: number}): Promise<Projects> => {
  return axios
    .get(`${DASHBOARD_URL}/projects`, {params: params || {}})
    .then((response: Response<Projects>) => response.data)
}

const getRecurringProjects = (): Promise<Projects> => {
  return axios
    .get(`${DASHBOARD_URL}/recurring-projects`)
    .then((response: Response<Projects>) => response.data)
}

const getOpenedProjects = (): Promise<Projects> => {
  return axios
    .get(`${DASHBOARD_URL}/opened-projects`)
    .then((response: Response<Projects>) => response.data)
}

const getRecentActivities = (): Promise<RecentActivitiesQueryResponse> => {
  return axios
    .get(`${DASHBOARD_URL}/recent-activities`)
    .then((response: Response<RecentActivitiesQueryResponse>) => response.data)
}

const getTimeTrackingByTeamId = (teamId: number | null, period: string = '7days'): Promise<TimeTrackingSquadRandomAdm> => {
  const params = new URLSearchParams()
  if (teamId) {
    params.append('team_id', teamId.toString())
  }
  params.append('period', period)
  return axios
    .get(`${DASHBOARD_URL}/timetracking-by-team?${params.toString()}`)
    .then((response: Response<TimeTrackingSquadRandomAdm>) => response.data)
}

const getTeams = (): Promise<any> => {
  // O endpoint /api/equipes/instance pega o instanceId do usuário autenticado
  return axios
    .get(`${API_URL}/api/equipes/instance`)
    .then((response: any) => {
      // A API retorna {teams: [...], message: '...'}
      if (response.data?.teams && Array.isArray(response.data.teams)) {
        return response.data
      }
      return {teams: []}
    })
    .catch((error) => {
      console.error('Error fetching teams:', error)
      return {teams: []}
    })
}

// AI Insights API
export const generateInsightByType = async (type: string) => {
  const response = await axios.post(`${API_URL}/api/ai-insights/generate-by-type`, { type })
  return response.data
}

export const getInsightHistory = async (limit: number = 10) => {
  const response = await axios.get(`${API_URL}/api/ai-insights/history?limit=${limit}`)
  return response.data
}

export const getInsightStats = async () => {
  const response = await axios.get(`${API_URL}/api/ai-insights/stats`)
  return response.data
}

export const checkRushMindAvailability = async () => {
  const response = await axios.get(`${API_URL}/api/ai-insights/check-availability`)
  return response.data
}

export {getDashboardInfo, getDashboardTrends, getDashboardInfoUser, getProjects, getRecurringProjects, getOpenedProjects, getRecentActivities, getTimeTrackingByTeamId, getTeams}
